export const translationTestPortals_sv = {
  pageTitle: "Testportaler",
  pageSubtitle:
    "Skapa delbara testportaler så att kunder och interna testare kan prova chatboten och ge strukturerad feedback — utan dashboard-inloggning.",
  createPortal: "Skapa testportal",
  createFirstPortal: "Skapa din första testportal",
  editPortal: "Redigera testportal",
  organizationPickerEyebrow: "Organisation",
  organizationPickerTitle: "Välj en organisation",
  organizationPickerSubtitle:
    "Välj den organisation vars testportaler du vill hantera. Portaler är synliga och redigerbara av användare i samma organisation.",
  organizationSearchPlaceholder: "Sök organisationer, domäner eller chatbot-ID:n",
  organizationLoadError: "Kunde inte läsa in organisationer.",
  organizationRequired: "Välj en organisation först.",
  selectedOrganization: "Organisation: {name}",
  changeOrganization: "Byt organisation",
  organizationsShowing: "Visar {count} av {total} organisationer",
  previous: "Föregående",
  next: "Nästa",
  pageOf: "Sida {page} av {pages}",
  loadingOrganizations: "Laddar organisationer...",
  noOrganizationsFound: "Inga organisationer hittades.",
  adminAccess: "Adminåtkomst",
  ownerAccess: "Ägaråtkomst",
  noDomainsConfigured: "Inga domäner konfigurerade",
  loading: "Laddar...",
  loadError: "Kunde inte läsa in testportaler.",
  saveError: "Kunde inte spara testportalen.",
  feedbackLoadError: "Kunde inte läsa in tester-feedback.",
  emptyTitle: "Inga testportaler ännu",
  emptySubtitle:
    "Skapa en testportal, välj de chatbotar du vill testa och dela länken med ditt team eller kunden.",
  active: "Aktiv",
  disabled: "Inaktiverad",
  enable: "Aktivera",
  disable: "Inaktivera",
  edit: "Redigera",
  delete: "Radera",
  cancel: "Avbryt",
  save: "Spara",
  saving: "Sparar...",
  chatbot: "chatbot",
  chatbots: "chatbotar",
  copyLink: "Kopiera länk",
  copied: "Kopierad",
  copyManualPrompt: "Kopiera den här länken manuellt:",
  viewFeedback: "Visa feedback",
  confirmDelete: 'Är du säker på att du vill radera "{name}"?',
  confirmDisable:
    'Inaktivering av "{name}" gör att delningslänken slutar fungera för testare. Fortsätt?',
  confirmDeleteFeedback: "Radera den här feedback-posten?",
  confirmRotateToken:
    'Att rotera token kommer omedelbart att ogiltigförklara den befintliga tester-delningslänken för "{name}". Fortsätt?',
  rotateToken: "Rotera länk",
  openPortal: "Öppna portal",
  shareLink: "Delningslänk",
  includedChatbots: "Inkluderade chatbotar",
  backToList: "Tillbaka till listan",
  created: "Skapad",
  testerFeedback: "Tester-feedback",
  test_feedback: "test-feedback",
  feedbackReportsDescription:
    "Tester-feedback lagras nu som vanliga konversationsrapporter med rapporttypen {type}. Använd befintliga konversationsfilter, kommentarer, statusändringar och exportflöden för att hantera den.",
  openFeedbackReports: "Öppna test-feedback rapporter",
  filterAllStatuses: "Alla statusar",
  noFeedbackYet: "Ingen feedback mottagen ännu.",
  statTotalFeedback: "Total feedback",
  statOpen: "Öppna",
  statHighSeverity: "Hög allvarlighet",
  statBugs: "Buggar",
  expectedAnswer: "Förväntat svar",
  testerInternal: "Intern testare",
  testerExternal: "Extern testare",
  fieldName: "Namn",
  namePlaceholder: "t.ex. Intern kundtjänsttest",
  fieldDescription: "Beskrivning",
  descriptionPlaceholder: "Berätta för testarna vad den här portalen handlar om...",
  fieldWelcomeMessage: "Välkomstmeddelande",
  welcomePlaceholder: "Välkommen! Prova chatboten och dela din feedback.",
  fieldChatbots: "Chatbotar",
  chatbotsHint: "Testare kan växla mellan de valda chatbotarna.",
  noChatbotsAvailable: "Inga chatbotar tillgängliga i ditt scope.",
  requireTesterIdentity: "Kräv namn/e-post från testare när de skickar feedback",
  fieldActive: "Portal är aktiv",
  nameRequired: "Namn krävs",
  chatbotRequired: "Välj minst en chatbot",
  status_open: "Öppen",
  status_in_review: "Under granskning",
  status_resolved: "Löst",
  status_dismissed: "Avvisad",
  category_bug: "Bugg",
  category_incorrect_answer: "Felaktigt svar",
  category_missing_info: "Saknad info",
  category_suggestion: "Förslag",
  category_general: "Allmänt",
  severity_low: "Låg",
  severity_medium: "Medium",
  severity_high: "Hög",
};
